import { useAuth } from '../contexts/AuthContext';
import { Clock, Mail, LogOut } from 'lucide-react';
import { logout } from '../lib/firebase';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

export default function PendingApproval() {
  const { currentUser, userProfile, loading } = useAuth();
  const navigate = useNavigate();

  // Rediriger si l'utilisateur est approuvé
  useEffect(() => {
    if (!loading && userProfile?.status === 'approved') {
      navigate('/app');
    } else if (!loading && userProfile?.status === 'rejected') {
      // Rediriger vers login si rejeté
      navigate('/login');
    }
  }, [userProfile, loading, navigate]);

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-dark flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-accent-blue"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-dark flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-dark-50 rounded-xl border border-dark-200 p-8 text-center">
        <div className="w-16 h-16 rounded-full bg-yellow-500/10 flex items-center justify-center mx-auto mb-6">
          <Clock className="w-8 h-8 text-yellow-400" />
        </div>
        
        <h1 className="text-2xl font-bold text-white mb-4">
          Compte en attente d'approbation
        </h1>
        
        <p className="text-gray-400 mb-6">
          Votre compte a été créé avec succès ! Un administrateur doit maintenant approuver votre demande d'accès à la plateforme.
        </p>
        
        <div className="bg-dark-100 rounded-lg p-4 mb-6">
          <div className="flex items-center gap-2 text-gray-300 mb-2">
            <Mail className="w-4 h-4" />
            <span className="text-sm">Compte créé pour :</span>
          </div>
          <p className="text-white font-medium">{currentUser?.email}</p>
          {userProfile?.firstName && userProfile?.lastName && (
            <p className="text-gray-400 text-sm">
              {userProfile.firstName} {userProfile.lastName}
            </p>
          )}
        </div>
        
        <p className="text-sm text-gray-500 mb-6">
          Vous recevrez un email de confirmation une fois votre compte approuvé. 
          En attendant, vous pouvez vous déconnecter et réessayer plus tard.
        </p>
        
        <button
          onClick={handleLogout}
          className="flex items-center gap-2 w-full justify-center px-4 py-2 bg-dark-200 text-gray-300 rounded-lg hover:bg-dark-300 transition-colors"
        >
          <LogOut className="w-4 h-4" />
          Se déconnecter
        </button>
      </div>
    </div>
  );
}